module.exports = __webpack_public_path__ + "static/media/thumbs-up-solid.02cea7e6.svg";